import { getDatabase, ref, child, update, get, set, remove, push } from "firebase/database";
import firebase, { auth } from "../../firebase/config";

export const setComHistory = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_COM_HISTORY]", data);
    dispatch({
      type: "SET_COM_HISTORY",
      payload: { history: data, loading: false },
    });
  };
};

export const setNewComHistory = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_COM]", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    set(ref(database, `communication_history/${item.ref.slice(4)}`), item);
    dispatch({
      type: "REMOVE_COM",
      // payload: { history: data, loading: false },
    });
  };
};

export const removeComHistory = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_COM]", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    console.log("removed:", `communication_history/${item}`);
    await remove(ref(database, `communication_history/${item}`));
    // await remove(ref(database, `analysis_history/${item}`));
    dispatch({
      type: "REMOVE_COM",
      // payload: { history: data, loading: false },
    });
  };
};

export const removeComHistoryLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    // connect to local emulator for debug locally
    console.log("[REMOVE_COM_LOCAL]", item);
    dispatch({ type: "REMOVE_COM_LOCAL", payload: item });
  };
};

const sort_analysis_history_by_date = async (analysis_history) => {
  var result = {};
  await Object.keys(analysis_history).forEach((key) => {
    result[key] = analysis_history[key];
    result[key]["createdAt"] = new Date(analysis_history[key]["createdAt"]);
  });
  console.log(result);

  const sorted_array = Object.entries(result).sort(function compare(a, b) {
    var dateA = a[1].createdAt;
    var dateB = b[1].createdAt;
    // console.log("dateA", dateA - dateB)
    return dateB - dateA;
  });

  var result_sorted = {};
  await sorted_array.map((x) => {
    result_sorted[x[0]] = x[1];
    const d = result_sorted[x[0]]["createdAt"];
    result_sorted[x[0]]["createdAt"] = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + ", " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
  });
  return result_sorted;
};

export const fetchComHistory = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[FETCH_COM_HISTORY]", item);
    const tenant_id = auth.currentUser.tenantId;
    const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));

    await get(child(dbRef, "communication_history/"))
      .then(async (snapshot) => {
        if (await snapshot.exists()) {
          const data = await snapshot.val();
          // console.log("[FETCH_ANALYSIS_HISTORY] - DONE:", data);
          const history_sorted = await sort_analysis_history_by_date(data);
          console.log("[FETCH_ANALYSIS_HISTORY] - DONE:", history_sorted);
          dispatch({
            type: "FETCH_COM_HISTORY",
            payload: { history: history_sorted, loading: false },
          });
        } else {
          dispatch({
            type: "FETCH_COM_HISTORY",
            payload: { history: [], loading: false },
          });
        }
      })
      .catch((error) => {
        console.error("[FETCH_COM_HISTORY] - ERROR:", error);
      });
  };
};

export const setComHistoryFiltred = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_COM_HISTORY_FILTRED]", data);
    dispatch({
      type: "SET_COM_HISTORY_FILTRED",
      payload: { history: data, loading: false },
    });
  };
};

export const getDiffMean = (analysis_id) => {
  return async (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    const tenant_id = auth.currentUser.tenantId;
    console.log("[GET_DIFF_MEAN]", analysis_id, tenant_id, process.env.REACT_APP_NODE_ENV);
    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/getDiffMean";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/getDiffMean";
    }
    let results;
    await fetch(`${url}?analysis_id=${encodeURIComponent(analysis_id)}&tenant_id=${encodeURIComponent(tenant_id)}`)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[getDiffMean sucess] - mean_diff: ", json.data);
        results = json.data.result;
        dispatch({ type: "GET_DIFF_MEAN", payload: json });
      });
    return results;
  };
};
